import { render, staticRenderFns } from "./prefectures.vue?vue&type=template&id=6a6adffa&scoped=true"
import script from "./prefectures.vue?vue&type=script&lang=js"
export * from "./prefectures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6adffa",
  null
  
)

export default component.exports